import { apiClient } from '@/lib/api/api-client';
import { ENDPOINTS } from '@/lib/api/endpoints';
import type {
  QuoteSummary,
  ModelSummary,
  SimulationParams,
  SimulationResult,
  JustificationParams,
  JustificationResult,
  PricingSuggestionsResult,
  ApprovalScoreResult,
  BusinessInsightsResult,
  ModelAnalysisResult,
} from '../types/ai-intelligence.types';

export const aiIntelligenceService = {
  getQuotesSummary: async (): Promise<QuoteSummary[]> => {
    return apiClient.get(ENDPOINTS.AI_INTELLIGENCE_QUOTES_SUMMARY);
  },

  getModelsSummary: async (): Promise<ModelSummary[]> => {
    return apiClient.get(ENDPOINTS.AI_INTELLIGENCE_MODELS_SUMMARY);
  },

  simulate: async (params: SimulationParams): Promise<SimulationResult> => {
    return apiClient.post(ENDPOINTS.AI_INTELLIGENCE_SIMULATE, params);
  },

  getJustification: async (params: JustificationParams): Promise<JustificationResult> => {
    return apiClient.post(ENDPOINTS.AI_INTELLIGENCE_JUSTIFICATION, params);
  },

  getSuggestions: async (params: {
    quoteId?: string;
    modelId?: string;
    clientName?: string;
  }): Promise<PricingSuggestionsResult> => {
    return apiClient.post(ENDPOINTS.AI_INTELLIGENCE_SUGGESTIONS, params);
  },

  getApprovalScore: async (quoteId: string): Promise<ApprovalScoreResult> => {
    return apiClient.post(ENDPOINTS.AI_INTELLIGENCE_APPROVAL_SCORE, { quoteId });
  },

  getInsights: async (period?: string, focus?: string): Promise<BusinessInsightsResult> => {
    return apiClient.post(ENDPOINTS.AI_INTELLIGENCE_INSIGHTS, { period, focus });
  },

  getModelAnalysis: async (modelId: string): Promise<ModelAnalysisResult> => {
    return apiClient.post(ENDPOINTS.AI_INTELLIGENCE_MODEL_ANALYSIS, { modelId });
  },
};
